import React from "react";
import { useEmailSections } from "../../Context/EmailSectionContext";

/**
 * Reusable style controls component for email components
 * Provides real-time style updates (fontFamily, primaryColor, secondaryColor, backgroundColor)
 */
const StyleControls = ({ id, componentName, styleSettings = {}, previewMode = false }) => {
  const { sections, updateSection } = useEmailSections();
  
  // Get current section data
  const sectionData = previewMode
    ? {}
    : sections.find(section => section.id === id) || {};
  
  // Get section-specific styles or fall back to parent styles
  const sectionStyleSettings = sectionData?.styleSettings || {};
  const currentFontFamily = sectionStyleSettings.fontFamily || styleSettings?.fontFamily || "helvetica, 'helvetica neue', arial, verdana, sans-serif";
  const currentPrimaryColor = sectionStyleSettings.primaryColor || styleSettings?.primaryColor || "#333333";
  const currentSecondaryColor = sectionStyleSettings.secondaryColor || styleSettings?.secondaryColor || "#a1894c";
  const currentBackgroundColor = sectionStyleSettings.backgroundColor || styleSettings?.backgroundColor || "#ffffff";
  
  // Real-time style update handler
  const handleStyleChange = (styleType, value) => {
    // Get current section data to preserve other fields
    const currentSection = sections.find(section => section.id === id) || {};
    const currentStyleSettings = currentSection.styleSettings || {};
    
    // Map styleType to property name
    const stylePropertyMap = {
      'fontFamily': 'fontFamily',
      'primaryColor': 'primaryColor',
      'secondaryColor': 'secondaryColor',
      'backgroundColor': 'backgroundColor'
    };
    
    // Update the specific style property
    const updatedStyleSettings = {
      ...currentStyleSettings,
      [stylePropertyMap[styleType]]: value
    };
    
    // Save immediately to section data
    updateSection(id, {
      ...currentSection,
      id,
      component_name: currentSection.component_name || componentName,
      styleSettings: updatedStyleSettings
    });
  };
  
  // Don't render in preview mode
  if (previewMode) {
    return null;
  }
  
  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <div className="d-flex align-items-center gap-1">
        <label className="form-label mb-0 me-1" style={{ fontSize: '12px', fontWeight: '500' }}>Font:</label>
        <select
          className="form-select form-select-sm"
          value={currentFontFamily}
          onChange={(e) => handleStyleChange('fontFamily', e.target.value)}
          style={{ width: '120px', fontSize: '12px' }}
        >
          <option value="helvetica, 'helvetica neue', arial, verdana, sans-serif">Helvetica</option>
          <option value="arial, sans-serif">Arial</option>
          <option value="georgia, times, serif">Georgia</option>
          <option value="verdana, geneva, sans-serif">Verdana</option>
          <option value="tahoma, geneva, sans-serif">Tahoma</option>
          <option value="trebuchet ms, helvetica, sans-serif">Trebuchet MS</option>
          <option value="times new roman, times, serif">Times New Roman</option>
        </select>
      </div>
      
      <div className="d-flex align-items-center gap-1">
        <label className="form-label mb-0 me-1" style={{ fontSize: '12px', fontWeight: '500' }}>Primary:</label>
        <input
          type="color"
          className="form-control form-control-color form-control-color-sm"
          value={currentPrimaryColor}
          onChange={(e) => handleStyleChange('primaryColor', e.target.value)}
          style={{ width: '30px', height: '30px', padding: '2px' }}
          title="Primary Color"
        />
      </div>
      
      <div className="d-flex align-items-center gap-1">
        <label className="form-label mb-0 me-1" style={{ fontSize: '12px', fontWeight: '500' }}>Secondary:</label>
        <input
          type="color"
          className="form-control form-control-color form-control-color-sm"
          value={currentSecondaryColor}
          onChange={(e) => handleStyleChange('secondaryColor', e.target.value)}
          style={{ width: '30px', height: '30px', padding: '2px' }}
          title="Secondary Color"
        />
      </div>
      
      <div className="d-flex align-items-center gap-1">
        <label className="form-label mb-0 me-1" style={{ fontSize: '12px', fontWeight: '500' }}>BG:</label>
        <input
          type="color"
          className="form-control form-control-color form-control-color-sm"
          value={currentBackgroundColor}
          onChange={(e) => handleStyleChange('backgroundColor', e.target.value)}
          style={{ width: '30px', height: '30px', padding: '2px' }}
          title="Background Color"
        />
      </div>
    </div>
  );
};

export default StyleControls;


